export type ValidationTriggerConfig = {
  /**
   * Dot-separated node paths that should not trigger web worker validation.
   * Examples: "position", "data.comments", "selected".
   *
   * Applied globally to every node in the graph, including parent and child nodes.
   * If a change affects only these paths (even on a parent), validation is skipped.
   */
  skipNodePaths: string[]
}

export const validationTriggerConfig: ValidationTriggerConfig = {
  skipNodePaths: [
    "*.position",
    "*.sourcePosition",
    "*.targetPosition",
    "*.selected",
    "*.dragging",
    "*.measured",
    "*.width",
    "*.height",
    "*.initialWidth",
    "*.initialHeight",
    "*.className",
    "*.style",
    "*.resizing",
    "*.focusable",
    "*.ariaRole",
    "*.domAttributes",
    "*.zIndex",
    "*.hidden",
    "*.draggable",
    "*.selectable",
    "*.connectable",
    "*.deletable",
    "*.dragHandle",
    "*.parentId",
    "*.extent",
    "*.expandParent",
    "*.ariaLabel",
    "*.origin",
    "*.handles",
    "*.data.comments",
    "*.data.color",
    "*.data.metaNode.color",
    "*.data.metaNode.Description",
    "*.data.metaNode.exportExcluded",
    "*.data.metaNode.groups",
    "*.data.metaGroup",
  ],
}
